const dropdownItem = document.querySelectorAll('.product-swatch__dropdown-item');
const caseID = document.querySelectorAll('.js-product-prop-case');
dropdownItem.forEach(function(btn) {
	btn.onclick = () => {
		// let caseCode = getRandomString(3);
		const ImgUrl = btn.getAttribute('data-image');
		const id = btn.getAttribute('data-id');
		const name = btn.getAttribute('data-name');
		const items = btn.closest('.js-swatch-label');
		const productIdx = items.getAttribute('data-product');
		const variantIdx = items.getAttribute('data-byoc-id');
		const productItems = document.querySelector(`.${ productIdx }`);
		const cartonArr = [];
		const activeItem =  items.querySelector('.product-swatch__dropdown-item.active');
		if(activeItem) {
			activeItem.classList.remove('active');
		}
		btn.classList.add('active');
		document.querySelector('.js-byoc-main-image').style.display = 'none';
		document.querySelector('.product-coast').style.display = 'grid';

		productItems.innerHTML = `<img class="js-product-coast-img" src="${ ImgUrl }">`;
		document.querySelector(`.${ variantIdx }`).value = id;

		// caseID.forEach(function(id) {
		// 	id.value = caseCode;
		// });

		items.setAttribute('data-name', name);
		const boxItems = document.querySelectorAll('.js-product-coast-img');
		if(boxItems.length === 4) {
			document.querySelector('.product-form__submit').removeAttribute('disabled');
		}

		const boxName = document.querySelectorAll('.js-swatch-label');
		boxName.forEach(function(label) {
			const title = label.getAttribute('data-name');
			cartonArr.push(title);
		});
		// groupBoxed(cartonArr);
	}
});

function groupBoxed(data) {
	const propertiesCarton = document.querySelector('.js-properties-own-carton');
	let count = {};
	data.forEach(function(i) {
		count[i] = ( count[i] || 0 ) + 1;
	});

	const result = Object.keys(count).map(function(key) {
		return [String(key + ' x '+ count[key])];
	});
	propertiesCarton.value = result;
	const formatString = propertiesCarton.value;
	propertiesCarton.value = formatString.replace(/,\s*/g, ", ");
}
